import React from "react";

const RemoveImageButton = ({ onClick, image = "none" }) => {
  if (!image || image === "none") return null;

  return (
    <button className="btn btn-form" onClick={onClick}>
      <i className="fa fa-trash"></i>
    </button>
  );
};

export default RemoveImageButton;
